module.exports = __webpack_public_path__ + "assets-cabinet/img/ru.7748a7e1.svg";